import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { useGetState } from '@/utils/hooks';
import { FI18n } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FIcons from '@/components/FIcons';
import {
  getPolicyTemplateInfos,
  PolicyTemplateInfo,
} from '@/components/fPolicyBuilder3/FPolicyBuilderDrawer3/PolicyTemplates';
import { canAddTransactionEventPolicy } from '@/components/fPolicyBuilder3/FPolicyBuilderDrawer3';

interface PolicyTemplatesProps {
  resourceTypeCode?: string;
  nodeID?: number;
  onSelect?(templateInfo: PolicyTemplateInfo): void;
}

function PolicyTemplates({ resourceTypeCode, nodeID, onSelect }: PolicyTemplatesProps) {
  const [$policyTemplates, set$policyTemplates, get$policyTemplates] = useGetState<
    PolicyTemplateInfo[]
  >([]);

  const [$open, set$open, get$open] = useGetState<boolean>(false);

  AHooks.useMount(async () => {
    set$policyTemplates(
      await getPolicyTemplateInfos({ resourceTypeCode: [resourceTypeCode || ''] }),
    );
  });

  return (
    <div>
      <div className={styles.policyTemplates}>
        {$policyTemplates
          .filter((pt, pti) => {
            return $open || pti < 4;
          })
          .map((pt, pi) => {
            return (
              <a
                key={pi}
                className={styles.policyTemplate}
                onClick={async () => {
                  if (
                    pt.displayData.some((item) => {
                      return item.id.includes('.TransactionEvent');
                    })
                  ) {
                    if (await canAddTransactionEventPolicy({})) {
                      onSelect?.(pt);
                    }
                    return;
                  }
                  onSelect?.(pt);
                }}
              >
                <FComponentsLib.FTitleText key={pt.id} text={pt.title} type={'h1'} />
                <div style={{ height: 15 }} />
                {/*<FComponentsLib.FContentText text={'公开（所有缔约方可签约）'} />*/}
                {/* {pt.translation
                  .split('\n')
                  .slice(0, 3)
                  .map((t, ti) => {
                    return <FComponentsLib.FContentText text={t} key={ti} singleRow={true} />;
                  })} */}
                <pre
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                    fontSize: 14,
                    color: '#222',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: '20px',
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {pt.translation}
                </pre>
              </a>
            );
          })}
      </div>
      <div style={{ height: 20 }} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {!$open && (
          <FComponentsLib.FTextBtn
            style={{ display: 'flex', alignItems: 'center', gap: 5 }}
            onClick={() => {
              set$open(true);
            }}
          >
            {/* <span>更多策略模板</span> */}
            <span>{FI18n.i18nNext.tAuto('authplanmgnt_btn_show_more_templates')}</span>
            <FIcons.FDown style={{ fontSize: 14 }} />
          </FComponentsLib.FTextBtn>
        )}

        {$open && (
          <FComponentsLib.FTextBtn
            style={{ display: 'flex', alignItems: 'center', gap: 5 }}
            onClick={() => {
              set$open(false);
            }}
          >
            <span>{FI18n.i18nNext.tAuto('authplanmgnt_btn_collapse')}</span>
            <FIcons.FUp />
          </FComponentsLib.FTextBtn>
        )}
      </div>
    </div>
  );
}

export default PolicyTemplates;
